import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import IdsTable from '../IdsTable';
import LoadMoreBtn from '../LoadMoreBtn';
import ListFilter from '../ListFilter';
import FollowedFilter from '../FollowedFilter';
import { useApi } from '../../context/ApiProvider';
import { Typography, Box } from '@mui/material';

const IdsSection = ({ dataFrom, title, showFavoritesFilter }) => {
  const [loading, setLoading] = useState(false);
  const [ids, setIds] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [paginationConfig, setPaginationConfig] = useState({
    order_by: 'track_meta.created_dt',
    order_direction: 'desc',
  });
  const [identifiedOnly, setIdentifiedOnly] = useState(false);

  const api = useApi();

  useEffect(() => {
    loadSets();
  }, [paginationConfig, dataFrom, identifiedOnly]);

  function onFilter(genre, sortBy, sortDirection) {
    let orderBy;
    if (sortBy === 'first_liked_date') {
      orderBy = 'user_track_favs.first_liked_date';
    } else if (sortBy === 'release_date') {
      // For IDs, sort by the identified track's release date
      orderBy = 'release.release_date';
    } else {
      orderBy = `track_meta.${sortBy}`;
    }

    setPaginationConfig({
      ...paginationConfig,
      genre: genre,
      order_direction: sortDirection,
      order_by: orderBy,
    });
  }

  const handleIdentifiedFilterChange = (event) => {
    const newValue = event.target.checked;
    setIdentifiedOnly(newValue);
  };

  async function loadSets() {
    setLoading(true);
    const endpoint = identifiedOnly ? `${dataFrom}/identified` : dataFrom;
    const response = await api.get(endpoint, paginationConfig);
    if (response.ok) {
      setIds(response.body.data);
      setPagination(response.body.pagination);
      setPage(1);
    } else {
      console.log(response);
    }
    setLoading(false);
  }

  async function loadMore() {
    setLoadingMore(true);
    const endpoint = identifiedOnly ? `${dataFrom}/identified` : dataFrom;
    const response = await api.get(endpoint, {
      ...paginationConfig,
      offset: 20 * page,
    });
    if (response.ok) {
      setIds([...ids, ...response.body.data]);
      setPagination(response.body.pagination);
      setPage(page + 1);
    } else {
      console.log(response);
    }
    setLoadingMore(false);
  }

  return (
    <>
      <Typography variant="h5" color={'white'}>
        {title}
      </Typography>
      <Box mb={6.5} textAlign="center">
        <Box mb={2}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            {showFavoritesFilter && (
              <FollowedFilter
                checked={identifiedOnly}
                onChange={handleIdentifiedFilterChange}
                mode="identified"
              />
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
              <ListFilter onFilter={onFilter} listType="ids" />
            </Box>
          </Box>
          {loading ? (
            <Box textAlign="center">
              <Loading alterColor />
            </Box>
          ) : (
            <IdsTable
              items={ids}
              onTableInteraction={setPaginationConfig}
              tableInteractionConfig={paginationConfig}
            />
          )}
        </Box>
        <LoadMoreBtn
          pagination={pagination}
          onLoadMoreClick={loadMore}
          loading={loadingMore}
        />
      </Box>
    </>
  );
};

IdsSection.propTypes = {
  dataFrom: PropTypes.string,
  title: PropTypes.string,
  showFavoritesFilter: PropTypes.bool,
};

export default IdsSection;
